import { ApiService }          from '../../app-lite/api/api.service';
import { CompanyMessagesModel }   from '../../app-lite/companies/models/company.messages';
import { TableService }           from '../../app-lite/table/table.service';
import { VendorPaymentsApiModel } from '../../app-lite/vendor-payments/models/vendor-payment.api'
import { VendorPaymentModel }     from '../../app-lite/vendor-payments/models/vendor-payment';

import VendorBranchPaymentHtml from '../../app-lite/vendor-payments/vendor-payment.branch.html';
import VendorHtml              from '../../app-lite/vendors/vendor.html';
import VendorPaymentHtml       from './vendor-payment.html';
import VendorsHtml             from '../../app-lite/vendors/vendors.html';

export function VendorsStates (
  $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'VendorsCtrl',
    name       : 'app.vendors',
    templateUrl: VendorsHtml,
    url        : '/vendors',
    resolve    : {
      companyMessages: ( $rootScope : any ) : ng.IPromise<CompanyMessagesModel> => $rootScope.Company.getDefaultMessages(),
      vendors        : ( tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> => {
        const cache = tableApi.getCacheForTable('vendors');

        return workshopAPI.stream('/filters', [
          cache.filtering.value ? cache.filtering.value : '*',
          'vendors',
          0,
          cache.paging.pageSize   || 10,
          cache.sorting.field     || 'company_name',
          cache.sorting.direction || 'asc',
          !!cache.filtering.archived_only
        ]);
      }
    }
  })
  .state({
    controller: 'VendorCtrl',
    name      : 'app.vendor',
    params    : {
      id: { squash: true, value: null }
    },
    templateUrl: VendorHtml,
    url        : '/vendor/:id',
    resolve    : {
      company        : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company'),
      companyMessages: ( $rootScope : any ) : ng.IPromise<CompanyMessagesModel> => $rootScope.Company.getDefaultMessages(),
      paymentTerms   : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('system/payment_term_types', null, 'paymentTerms'),
      vendor         : ( $stateParams : ng.ui.IStateParamsService, Vendor ) : ng.IPromise<any> => Vendor.get($stateParams.id),
      billedVendors  : ( $stateParams : ng.ui.IStateParamsService, tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> => {
        const cache = tableApi.getCacheForTable('vendorBilled');

        return $stateParams.id
          ? workshopAPI.get('/vendors/biller_child_list', [
            $stateParams.id,
            0,
            cache.paging.pageSize || 5
          ])
          : [];
      },
      invoices: ( $stateParams : ng.ui.IStateParamsService, tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> => {
        const cache = tableApi.getCacheForTable('vendorInvoices');

        return $stateParams.id
          ? workshopAPI.get('/vendors/invoice_list', [
            $stateParams.id,
            0,
            cache.paging.pageSize || 5,
            cache.filtering.status_type ? cache.filtering.status_type : '*',
            '*',
            cache.filtering.import_type ? cache.filtering.import_type : '*',
            cache.filtering.begin_date  ? cache.filtering.begin_date  : '*',
            cache.filtering.end_date    ? cache.filtering.end_date    : '*',
            cache.sorting.field     || 'post_date',
            cache.sorting.direction || 'desc'
          ])
          : [];
      },
      orders: ( $stateParams : ng.ui.IStateParamsService, tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> => {
        const cache = tableApi.getCacheForTable('vendorOrders');

        return $stateParams.id
          ? workshopAPI.get('/vendors/purchase_order_list', [
            $stateParams.id,
            0,
            cache.paging.pageSize   || 5,
            '*',
            cache.sorting.field     || 'order_date',
            cache.sorting.direction || 'desc'
          ])
          : [];
      },
      payments: ( $stateParams : ng.ui.IStateParamsService, tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> => {
        const cache = tableApi.getCacheForTable('vendorPayments');

        return $stateParams.id
          ? workshopAPI.get('/vendors/payment_list', [
            $stateParams.id,
            0,
            cache.paging.pageSize   || 5,
            cache.sorting.field     || 'post_date',
            cache.sorting.direction || 'asc'
          ])
          : [];
      }
    }
  })
  .state({
    controller: 'VendorPaymentCtrl',
    name      : 'app.vendor-payment',
    params    : {
      id       : { squash: true, value: null },
      vendor_id: { squash: true, value: null }
    },
    templateUrl: VendorPaymentHtml,
    url        : '/:vendor_id/vendor_payment/:id',
    resolve    : {
      payment: ( $stateParams : ng.ui.IStateParamsService, vendorPaymentsApi : VendorPaymentsApiModel ) : ng.IPromise<VendorPaymentModel> => vendorPaymentsApi.get($stateParams.vendor_id, $stateParams.id ?? undefined),
      vendor : ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | string =>
        $stateParams.vendor_id
          ? workshopAPI.get('/vendor', $stateParams.vendor_id)
          : ''
    }
  })
  .state({
    controller: 'VendorBranchPaymentCtrl',
    name      : 'app.vendor-branch-payment',
    params    : {
      id: { squash: true, value: null }
    },
    templateUrl: VendorBranchPaymentHtml,
    url        : '/:vendor_id/branch_vendor_payment/:id',
    resolve    : {
      settings: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_accounting_settings'),
      payment : ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | undefined =>
        $stateParams.id
          ? workshopAPI.get('/branch_vendor_payment', $stateParams.id)
          : undefined,
      vendor: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | undefined =>
        $stateParams.vendor_id
          ? workshopAPI.get('/vendor', $stateParams.vendor_id)
          : undefined
    }
  });
}